module.exports = __webpack_public_path__ + "static/media/collapse.06843a0c.svg";